import React from 'react'
import HighSchoolPreviewBanner from './component'
import { BANNER_DEFAULT_STRONG_TEXT } from './constants'

const HighSchoolPreviewBannerContainer = () => (
  <HighSchoolPreviewBanner strongText={BANNER_DEFAULT_STRONG_TEXT} />
)

export default HighSchoolPreviewBannerContainer
